import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetContractDetails,
  GetContractDetailsVariables
} from '@/graphql/contracts/_generated_/getContractDetails.query';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';


export default function useGetContractDetails(contractId: UUID) {
  const { data, error, loading } = useQuery<GetContractDetails, GetContractDetailsVariables>(
    GetContractDetailsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      variables: { contractId }
    }
  );

  return {
    contract: data?.contract,
    isContractLoading: loading,
    errorLoadingContract: error,
  } as const;
}
